import { createTRPCReact } from "@trpc/react-query";
import type { inferRouterOutputs } from "@trpc/server";
import type { AppRouter } from "../../../server/routers";

export const trpc = createTRPCReact<AppRouter>();

/**
 * Correctly-inferred output types for every procedure, e.g.
 * `RouterOutputs["team"]["departmentReport"]`.
 *
 * Use this — NOT `ReturnType<typeof trpc.x.y.useQuery>["data"]`.
 * `useQuery` is overloaded, so `ReturnType` resolves the *last*
 * overload and collapses `data` to `{}` (silently breaking every
 * downstream property access). `inferRouterOutputs` reads the router
 * contract directly and is immune to that.
 */
export type RouterOutputs = inferRouterOutputs<AppRouter>;
